module.exports = function (btsUi) {

    btsUi.directive('toolContainer',function ($timeout,$rootScope,$window) {

        return {

            link:{post:

                function toolContainer($scope, element, attrs, ctrls) {


                    function getVisibleToolsCount(){
                        return element.find('.healthTool').not('.aem-GridColumn--default--hide').find('.tool-active').length;
                    }
                    function getInitColumns(){
                        var initColumns=5;
                        var windowWidth = $window.innerWidth;
                        if(windowWidth >1 && windowWidth <=456){
                            initColumns = 3;
                        }else if(windowWidth >456 && windowWidth <=768){
                            initColumns =5;
                        }else if(windowWidth >768){
                            initColumns = 5;
                        }
                        return initColumns;
                    }
                    var updateToolWidth =function(toolsCount,initColumns){
                        if(toolsCount){
                            var width = 100/initColumns;
                            if(toolsCount>initColumns){
                                var emptyColumns=initColumns;
                                var maxColumnsPerRow = initColumns;
                                //finding out number of gaps remaining in the last row  for each set of columns like 5 or 4 or 3 per row
                                // choose the number of columns which give less gaps in the last row.
                                for(var colPerRow=initColumns;colPerRow>1;colPerRow--){
                                    if(toolsCount%colPerRow==0){
                                        maxColumnsPerRow = colPerRow;
                                        break;
                                    }else{
                                        var remEmptyColumns = colPerRow-(toolsCount%colPerRow);
                                        if(remEmptyColumns<emptyColumns){
                                            emptyColumns = remEmptyColumns;
                                            maxColumnsPerRow = colPerRow;
                                        }
                                    }

                                }
                                width = 100/maxColumnsPerRow;
                            }else{
                                var width = 100/toolsCount;
                            }
                            element.find('.healthTool').css({'width': width+"%"});
                        }

                    }
                  /*  $scope.$watch(getWindowInnerWidth,function(updatedWindowWidth){
                        
                        var toolCount = getVisibleToolsCount();
                        var initColumns=5;
                        if(updatedWindowWidth <480){
                            initColumns = 3;
                        }
                        updateToolWidth(toolCount,initColumns);
                    });*/

                    $scope.$watch(getVisibleToolsCount,function(newToolsCount){

                        var initColumns  =getInitColumns();

                        updateToolWidth(newToolsCount,initColumns);

                    });



                }
            }

        };
    });
}
